import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = (category) =>
  api.get("/products", { params: category && category !== "all" ? { category } : {} }).then((r) => r.data);

export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);

export const getSets = () => api.get("/sets").then((r) => r.data);

export const postNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);

export const submitQuiz = (answers) => api.post("/quiz", answers).then((r) => r.data);

export const createCheckout = (items, origin_url) =>
  api.post("/checkout/session", { items, origin_url }).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
